<template>
  <div class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex items-center gap-1 h-9 text-l-medium text-black-white">
      <Icon icon="Writing-Wireframe-Certificate" class="size-6" />
      <span>{{ $t('setting.about.copyright.title') }}</span>
    </div>

    <p class="text-s-medium text-text-glass-default">
      © {{ $t('setting.about.copyright.description') }}
      <!-- <a href="#" class="text-brand-blue1 ml-1 underline">
        {{ $t('setting.about.copyright.openSourceLicense') }}
      </a> -->
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { Icon } from '@rapoo/element'
</script>
